import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'La guía me ayudó a entender mejor lo que le pasaba a mi hijo antes y después de los partidos. Ahora sé cómo acompañarlo sin meterle más presión.',
    name: 'Mauricio B.'
  }, {
    quote: 'Mi hijo se frustraba muchísimo con cada error. Con este material empecé a hablarle de otra manera y noté un cambio muy grande en su confianza.',
    name: 'Verónica R.'
  }, {
    quote: 'Lo que más me gustó es que no son frases vacías. Son herramientas concretas para ayudar de verdad a un chico que compite con miedo.',
    name: 'Sebastián M.'
  }, {
    quote: 'Sentí que por fin alguien explicaba con claridad lo que muchos padres vemos y no sabemos cómo manejar.',
    name: 'Natalia P.'
  }, {
    quote: 'La guía me abrió los ojos. Yo pensaba que lo ayudaba, pero muchas veces lo presionaba más. Me sirvió muchísimo.',
    name: 'Gustavo H.'
  }, {
    quote: 'Mi hijo volvió a entrar a la cancha con otra actitud. No digo que todo se resolvió de un día para el otro, pero sí empezó a sentirse más seguro.',
    name: 'Andrea C.'
  }, {
    quote: 'Nos ayudó como familia. Bajó mucho la tensión en casa y aprendimos a acompañar mejor los días difíciles.',
    name: 'Federico L.'
  }, {
    quote: 'Es un material muy valioso para cualquier padre que vea a su hijo sufrir más de la cuenta por el fútbol.',
    name: 'Lorena Suárez'
  }, {
    quote: 'Me gustó porque habla tanto del jugador como del rol de la familia. Eso lo hace mucho más útil y real.',
    name: 'Paula Navarro'
  }, {
    quote: 'Mi hijo tenía talento, pero la presión lo bloqueaba. Esta guía me dio herramientas para empezar a trabajar justo esa parte.',
    name: 'Cristian Varela'
  }, {
    quote: 'Después de leerla, entendí que el problema no era solo futbolístico. También había una carga emocional que no estábamos sabiendo acompañar.',
    name: 'Romina F.'
  }, {
    quote: 'La recomendaría porque te da claridad, estructura y una forma más sana de vivir el proceso deportivo de tu hijo.',
    name: 'Daniel M.'
  }, {
    quote: 'Me ayudó a cambiar completamente la forma en que hablaba con mi hijo después de los partidos.',
    name: 'Carolina J.'
  }, {
    quote: 'Lo mejor es que está pensado para aplicar de inmediato. No se queda en teoría.',
    name: 'Martín S.'
  }, {
    quote: 'Este material me dio tranquilidad porque por fin sentí que tenía herramientas reales para ayudar a mi hijo.',
    name: 'Elena R.'
  }];
  return <section className="py-20 md:py-28 bg-white" data-id="element-184">
      <div className="max-w-5xl mx-auto px-5 sm:px-6 lg:px-8" data-id="element-185">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="text-center mb-12 md:mb-16" data-id="element-186">
          <h2 className="text-3xl md:text-4xl font-heading text-brand-slate mb-4 leading-tight" data-id="element-187">
            Lo que dicen las familias que ya lo tienen
          </h2>
          <div className="flex justify-center items-center gap-1 mb-4" data-id="element-188">
            {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="w-5 h-5 fill-brand-amber text-brand-amber" data-id="element-189" />)}
          </div>
          <p className="text-base md:text-lg text-brand-slate-light" data-id="element-190">
            Basado en la experiencia de cientos de padres.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-191">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="bg-white p-6 md:p-8 rounded-2xl border border-gray-100 flex flex-col h-full" data-id="element-192">
              <QuoteIcon className="w-6 h-6 text-gray-200 mb-4" data-id="element-193" />

              <div className="flex mb-4" data-id="element-194">
                {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="w-3.5 h-3.5 fill-brand-amber text-brand-amber" data-id="element-195" />)}
              </div>

              <p className="text-base text-brand-slate-light leading-relaxed mb-6 flex-grow" data-id="element-196">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center mt-auto pt-4 border-t border-gray-50" data-id="element-197">
                <div className="w-10 h-10 rounded-full flex items-center justify-center font-medium text-sm mr-3 bg-[#f8f9fa] text-brand-slate" data-id="element-198">
                  {testimonial.name.charAt(0)}
                </div>
                <div data-id="element-199">
                  <p className="font-medium text-brand-slate text-sm" data-id="element-200">
                    {testimonial.name}
                  </p>
                  <p className="text-xs text-brand-slate-muted" data-id="element-201">
                    Padre/Madre verificado
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}